<template>
    <dx-grid
        :url="url"
        :columns="columns"
        :title="title"
        :actions="actions"
        :onRowClicked="onRowClicked"
        navigationPath="onRowClicked"
        navigationField="onRowClicked"
        :beforeSetupGrid="beforeSetupGrid"
        ref="grid"
        :expandedOptions="{
            enabled: true,
            allowExpandingAll: true,
            template: 'ykc-account-details',
        }"
    ></dx-grid>
</template>

<script>
import { formatCurrency } from "../../utils/helpers.js";

export default {
    data: () => ({
        title: "Accounts Extended",
        activeTab: "basic",
        basicCount: 0,
        extendedCount: 0,

        actions: [],
        url: "",

        regID: "",
        phoneSearch: "",

        columns: [
            {
                field: "name",
                label: "Name",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "nameH",
                label: "Hebrew Name",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "accountID",
                label: "Account ID",
                format: "",
                //link: "YKCAccountView",
                //template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "emailAddress",
                label: "Email Address",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "homePhone",
                label: "Home Phone",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "students",
                label: "Students",
                format: "",
                type: "number",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "missingDocs",
                label: "Missing Docs",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "registrationStatus",
                label: "Registration Status",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "address1",
                label: "Address",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "cellPhone",
                label: "Cellphone",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            // {
            //     field: "date",
            //     label: "Date",
            //     type: "date",
            //     format: "",
            //     visible: true,
            //     filterType: "",
            //     format: "MM/dd/yyyy hh:mm:ss a",
            //     sortOrder: "desc",
            //     sortIndex: 0,
            //     filterValues: [],
            //     filterValue: null,
            //     selectedFilterOperation: null,
            // },
            {
                field: "balance",
                label: "Balance",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "actualBalance",
                label: "Actual Balance",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "previousBalance",
                label: "Previous Balance",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "debit",
                label: "Billed",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "totalPaid",
                label: "Total Paid",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "paid",
                label: "Paid",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "credit",
                label: "Credit",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "scheduledPayments",
                label: "ScheduledPayments",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Lunch Document Status",
                field: "lunchDocumentStatus",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: false,
            },
            {
                field: "followUpDate",
                label: "Follow Up Date",
                format: "",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy",
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "followUpNote",
                label: "Follow Up Note",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            // {
            //     label: "Non UTA",
            //     field: "nonUTA",
            //     type: "boolean",
            //     filterValues: [],
            //     filterValue: null,
            //     selectedFilterOperation: null,
            //     visible: false,
            // },
        ],
    }),
    async created() {},
    methods: {
        async beforeSetupGrid() {
            await this.loadRegID();

            const terms = await this.getTerms();

            this.actions.push({
                text: "Phone Number",
                type: "input",
                inputType: "number",
                mask: "###-###-####",
                align: "left",
                value: this.phoneSearch,
                onChanged: this.onPhoneNumberSearch,
                clearable: true,
            });

            this.actions.push({
                text: "Select Term",
                type: "select",
                values: terms.map((t) => t.term),
                value: this.regID,
                onSelected: this.onTermSelected,
            });
            // this.actions.push({
            //     text: "Add Family",
            //     action: this.addFamily,
            // });

            this.url =
                "yKCAccounts?regID=" +
                this.regID +
                (this.phoneSearch ? "&phone=" + this.phoneSearch : "&phone=");
        },
        async loadRegID() {
            this.regID = await this.$http.get("api/yk/getRegID");
        },
        async getTerms() {
            return await this.$http.get("api/yk/getRegTerms");
        },
        async onRowClicked(row) {
            this.$router.push({
                name: "YKCAccountView",
                params: { id: row.accountID, reg_id: row.regID },
            });
        },
        addFamily() {
            this.$router.push({
                name: "YKApply",
            });
        },
        onTermSelected(value) {
            this.regID = value;

            this.reloadDataSource();
        },
        onPhoneNumberSearch(value) {
            this.phoneSearch = value ? value.replaceAll("-", "") : "";

            this.reloadDataSource();
        },
        reloadDataSource() {
            this.url =
                "yKCAccounts?regID=" +
                this.regID +
                (this.phoneSearch ? "&phone=" + this.phoneSearch : "&phone=");

            this.$refs.grid.reloadDataSource(this.url);
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
</style>
